import * as React from "react";
import { useMemo } from "react";
import merge from "lodash/merge";
import SearchPageLayoutContext, { DEFAULT_STATE } from "./SearchPageLayoutContext";
const SearchPageLayoutProvider = ({ children, value }) => {
  const contextValue = useMemo(() => merge({}, DEFAULT_STATE, value), [value]);
  return /* @__PURE__ */ React.createElement(SearchPageLayoutContext.Provider, { value: contextValue }, children);
};
export default SearchPageLayoutProvider;
